import "./App.css";
import React from 'react';
import HomePage from "./components/HomePage"

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <HomePage />
      </header>
    </div>
  );
}

export default App;
